import React from 'react';
import styled from 'styled-components';
import profilePhotoo from '../../../../src/assets/images/profile.jpg';

const AboutContainer = styled.div`
  padding: 30px;
  font-family: 'Ubuntu', sans-serif;
  color: #00ff00;
  background: rgba(0, 0, 0, 0.8);
  height: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const ProfileSection = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ProfileImageContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid rgba(0, 255, 0, 0.5);
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.3);
  object-fit: cover;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
  }
`;

const ProfileImageFallback = styled.div`
  width: 150px;
  height: 150px;
  background: linear-gradient(45deg, #00ff00, #00ffff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  border: 3px solid rgba(0, 255, 0, 0.5);
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
  }
`;

const InfoSection = styled.div`
  flex: 1;
`;

const Title = styled.h1`
  color: #00ff00;
  margin-bottom: 10px;
  font-size: 2.5em;
`;

const Subtitle = styled.h2`
  color: #00ffff;
  margin-bottom: 15px;
  font-size: 1.5em;
`;

const Description = styled.p`
  line-height: 1.6;
  margin-bottom: 20px;
  color: #cccccc;
`;

const FactsList = styled.ul`
  list-style: none;
  padding: 0;
`;

const FactItem = styled.li`
  margin-bottom: 10px;
  padding: 8px;
  background: rgba(0, 255, 0, 0.1);
  border-left: 3px solid #00ff00;
  border-radius: 4px;
`;

const ContactInfo = styled.div`
  background: rgba(0, 255, 0, 0.1);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid rgba(0, 255, 0, 0.3);
`;

const AboutApp: React.FC = () => {
  // For now, using a placeholder. Replace with your actual photo import
  const profilePhoto = profilePhotoo ;

  return (
    <AboutContainer>
      <Header>
        <Title>MUKUL JOSHI</Title>
        <Subtitle>Cybersecurity Enthusiast & Ethical Hacker</Subtitle>
      </Header>
      
      <ProfileSection>
        <ProfileImageContainer>
          {profilePhoto ? (
            <ProfileImage src={profilePhoto} alt="Mukul Joshi" />
          ) : (
            <ProfileImageFallback>🛡️</ProfileImageFallback>
          )}
        </ProfileImageContainer>
        
        <InfoSection>
          <Description>
            Passionate cybersecurity professional specializing in ethical hacking, penetration testing, 
            and secure system development. Currently pursuing Bachelor of Engineering in Computer Science 
            at Army Institute of Technology, with hands-on experience in IoT Security and digital forensics.
          </Description>
          
          <FactsList>
            <FactItem>🔐 Cybersecurity Specialist & Penetration Tester</FactItem>
            <FactItem>🐧 Linux System Administrator</FactItem>
            <FactItem>💻 Full-Stack Developer (React, Django, Python)</FactItem>
            <FactItem>🎯 CTF Player - Multiple Top Rankings</FactItem>
            <FactItem>🏆 Joint Secretary, ISDF Club at AIT</FactItem>
            <FactItem>🎸 Musician - Guitarist & Flute Player</FactItem>
          </FactsList>
        </InfoSection>
      </ProfileSection>

      <ContactInfo>
        <h3>Contact Information</h3>
        <p>📧 Email: memukuljoshi@gmail.com</p>
        <p>📱 Phone: +91-7078153883</p>
        <p>🎓 Institution: Army Institute of Technology, Pune</p>
        <p>📅 Expected Graduation: June 2027</p>
      </ContactInfo>
    </AboutContainer>
  );
};

export default AboutApp;
